import { useTranslation } from "react-i18next";
import { InfoCircle } from "../../assets/icons";
import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";

import "./index.scss";

const CommentsOnSpecialElements = ({ commentsData = [] }) => {
  const { t } = useTranslation();

  if (!commentsData || commentsData.length === 0) {
    return null;
  }

  return (
    <div className="comments-on-special-elements-container">
      <div className="comments-header">
        <InfoCircle className="info-icon" />
        <h3 className="comments-title">
          {t("RONFConfiguration.commentsOnSpecialElements")}
        </h3>
      </div>

      <div className="comments-columns-grid">
        {commentsData.map((item, index) => {
          const visibleElements = item.elements.slice(0, 2);
          const hiddenElements = item.elements.slice(2);
          const hasMore = hiddenElements.length > 0;

          return (
            <div key={index} className="comments-column">
              <div className="comments-elements-container">
                {visibleElements.map((element, elemIndex) => (
                  <div key={elemIndex} className="comments-badge">
                    {element}
                  </div>
                ))}
                {hasMore && (
                  <CustomTooltip
                    title={
                      <ul className="tooltip-elements-list">
                        {hiddenElements.map((element, elemIndex) => (
                          <li key={elemIndex}>{element}</li>
                        ))}
                      </ul>
                    }
                  >
                    <div className="more-elements">
                      +{hiddenElements.length}
                    </div>
                  </CustomTooltip>
                )}
              </div>
              <div className="comments-description">
                {t(`RONFConfiguration.${item.comment}`)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommentsOnSpecialElements;
